module.exports = __webpack_public_path__ + "img/mixerstu2.88bf191e.jpeg";